import React from 'react'
import { FlowActions as BaseFlowActions } from 'components'
import { Path } from 'config/portal'
import PropTypes from 'prop-types'

const propTypes = {
  exitPath: PropTypes.string,
}

const defaultProps = {
  exitPath: Path.SERVICES_AGREEMENTS,
}

function FlowActions(props) {
  return <BaseFlowActions {...props} />
}

FlowActions.propTypes = propTypes
FlowActions.defaultProps = defaultProps

export default React.memo(FlowActions)
